// @flow

import ReactGA from "react-ga";
import { isProd } from "../rest/utils/envDetection";

function initialiseEvents() {
    if (!isProd) {
        console.log("EVENTS Init DEV events");
    } else ReactGA.initialize("UA-123827431-1");
}

function pageview(page) {
    if (!isProd) {
        console.log("EVENTS pageview", page);
    } else ReactGA.pageview(page);
}

function event(e) {
    if (!isProd) {
        console.log("EVENTS event", e);
    } else ReactGA.event(e);
}

export { initialiseEvents, pageview, event };



// WEBPACK FOOTER //
// ./src/utils/events.js